<template>
  <ListingBlock
    :view="view"
    :docs="view.docs().filteredDocs.slice(0, 3)"
    :docViewEventProperties="docViewEventProperties"
  />
</template>

<script setup lang="ts">
import ListingBlock from '@/app/components/listing/ListingBlock.vue'

import type { ListView } from '@/models/docs.list'
import type { ListItem } from '@/models/interfaces'

defineProps<{
  view: ListView
  docViewEventProperties?: (doc: ListItem) => Record<string, unknown>
}>()
</script>
